import { createApp } from 'vue';
import './assets/main.css';
import App from './App.vue';
import router from './router';
import store from './store';
import DashboardLayout from './components/DashboardLayout.vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const app = createApp(App);

app.component('default-layout', DashboardLayout);

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const selectedFacility = store.getters['auth/selectedFacility'];

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' });
  } else if (to.meta.requiresAuth && isAuthenticated && !selectedFacility) {
    // Redirect to login if no facility is selected
    next({ name: 'Login' });
  } else {
    next();
  }
});

app.use(router);
app.use(store);
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
});

// Safely initialize auth
store.dispatch('auth/initializeAuth')
  .then(() => {
    console.log('Auth initialized successfully');
  })
  .catch((err) => {
    console.error('Auth initialization failed:', err);
  });

app.mount('#app');